import React from 'react'
import machineImg from '../../../images/puzzles/theMachine/machine.png'

function EndingPopUp() {
    return (
        <div className='puzzleContainer'>
            <img className='puzzlePopUp_img' src={machineImg} alt='the machine' />
            <p className='puzzlePopUp_text'>
                The machine noisily grinds to a halt as power drains from the control panel. You can hear sirens arriving outside.<br /><br />
                <em>'Better late than never'</em><br /><br />
                Larry mumbles under his breath.
            </p><br />
            <p className='puzzlePopUp_text puzzlePopUp_text-ending'>Congratulations! You solved the case!</p>
        </div>
    )
}

export default EndingPopUp